<script lang="ts">
  import { defineComponent } from 'vue';
  import StationLoaderAnimation from '@/components/ui/animations/StationLoaderAnimation.vue';

  export default defineComponent({
    components: { StationLoaderAnimation },
  });
</script>

<template>
  <div
    class="station-loader h-100 w-100 d-flex flex-column align-items-center justify-content-center"
  >
    <div class="animation-container">
      <StationLoaderAnimation class="w-100 h-auto" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .station-loader {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: $white;

    .animation-container {
      width: 40%;
    }
  }
</style>
